import { defineMessages } from 'react-intl-next';

export default defineMessages({
    helpDeskAddErrorTitle: {
        defaultMessage: 'We couldn’t create your team',
        description: 'Title message for add help desk error',
        id: 'uh.help.desk.add.error.title',
    },
    helpDeskAddSuccessTitle: {
        defaultMessage: `You’ve created {value}`,
        description: 'Title message for add help desk success',
        id: 'uh.help.desk.add.success.title',
    },
    helpDeskErrorDesc: {
        defaultMessage: 'Wait a moment and then try again.',
        description: 'Description message for add help desk error',
        id: 'uh.help.desk.add.error.description',
    },
    helpDeskSuccessDesc: {
        defaultMessage: 'Add resources that we can use when someone asks a question related to your team.',
        description: 'Description message for add help desk success',
        id: 'uh.help.desk.add.success.description',
    },
    addFormHeader: {
        defaultMessage: 'Create a team',
        description: 'Add helpdesk form header',
        id: 'uh.help.desk.add.form.header',
    },
    addFormDesc: {
        defaultMessage: 'Add details to explain how can your team help others.',
        description: 'Add helpdesk form description',
        id: 'uh.help.desk.add.form.description',
    },
    addHelpDeskFormSubmitButton: {
        defaultMessage: 'Create',
        description: 'Add helpdesk form submit button',
        id: 'uh.help.desk.add.submit.button',
    },
});
